import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite';

import Translatable from '../../../../components/Translatable';
import FilterButtonBar from './FilterButtonBar';

import { display } from '../../../../commonStyles.js';
import styles from './styles.js';

import {
    filterActions,
    adminActions
} from '../../actions';

import { getActiveFilterGroupCollectionPanelType } from '../../selectors';

const mapStateToProps = state => ({
    activeFilterGroupCollectionIndex: state.activeFilterGroupCollectionIndex,
    activeFilterGroupCollectionPanelType: getActiveFilterGroupCollectionPanelType(state),
    apiUrl: state.config.apiUrl,
    contentLoading: state.contentLoading,
    mapState: state.mapState,
    initialContentLoaded: state.initialContentLoaded,
    isAdmin: state.navigation.user.isAdmin,
    searchParams: state.searchParams,
    trackingCookieId: state.config.trackingCookieId,
    unstable: state.mapState.unstable,
    userLang: state.config.userLang
});

const mapDispatchToProps = dispatch => ({
    setActiveFilterGroupCollection: filterGroupCollectionIndex =>
        dispatch(filterActions.setActiveFilterGroupCollection(filterGroupCollectionIndex)),
    toggleAdminMode: (apiUrl, userLang, location, tag, params, trackingCookieId, adminModeId) =>
        dispatch(adminActions.setAdminModeAndSearch(apiUrl, userLang, location, tag, params, trackingCookieId, adminModeId))
});

class FilterBar extends Component {
    static propTypes = {
        activeFilterGroupCollectionIndex: PropTypes.number.isRequired,
        activeFilterGroupCollectionPanelType: PropTypes.string.isRequired,
        apiUrl: PropTypes.string.isRequired,
        contentLoading: PropTypes.bool.isRequired,
        filterGroupCollections: PropTypes.array.isRequired,
        getActiveFilters: PropTypes.number.isRequired,
        initialContentLoaded: PropTypes.bool.isRequired,
        isAdmin: PropTypes.bool.isRequired,
        mapState: PropTypes.object.isRequired,
        setActiveFilterGroupCollection: PropTypes.func.isRequired,
        toggleFullScreenPanel: PropTypes.func.isRequired,
        toggleMapPanel: PropTypes.func.isRequired,
        unstable: PropTypes.bool.isRequired,
        userLang: PropTypes.string.isRequired
    }

    state = {
        filterGroupCollections: this.props.filterGroupCollections
    }

    updateFilterGroupCollection = (filterGroupCollectionIndex, updatedFilterGroupCollection) => {
        const { filterGroupCollections } = this.props;
        const updatedFilterGroupCollections = filterGroupCollections.map(
            (filterGroupCollection, index) => {
                if (index !== filterGroupCollectionIndex) {
                    return filterGroupCollection;
                }
                return updatedFilterGroupCollection;
            }
        );
        this.setState(prevState => ({
            ...prevState,
            filterGroupCollections: updatedFilterGroupCollections
        }));
    }

    toggleAdminMode = (event) => {
        const { apiUrl, searchParams, toggleAdminMode, trackingCookieId, userLang } = this.props;
        const location = decodeURIComponent(window.location.pathname.split('/')[4]);
        const tag = {
            quick_slug: decodeURIComponent(window.location.pathname.split('/')[3])
        };
        toggleAdminMode(apiUrl, userLang, location, tag, searchParams, trackingCookieId, event.target.value);
    }

    render() {
        const {
            updateFilterGroupCollection,
            toggleAdminMode
        } = this;
        const {
            activeFilterGroupCollectionIndex,
            activeFilterGroupCollectionPanelType,
            contentLoading,
            filterGroupCollections,
            getActiveFilters,
            initialContentLoaded,
            isAdmin,
            mapState,
            setActiveFilterGroupCollection,
            toggleFullScreenPanel,
            toggleMapPanel,
            unstable
        } = this.props;
        return (
            <div>
                <div className={css(styles.filterBarSection)}>
                    <div className={css(styles.filterBarWrapper)}>
                        {
                            (initialContentLoaded && !contentLoading && !unstable) ?
                                null :
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        bottom: 0,
                                        left: 0,
                                        backgroundColor: 'rgba(255, 255, 255, 0.6)',
                                        zIndex: 5
                                    }}
                                />
                        }
                        {
                            activeFilterGroupCollectionIndex !== -1 ?
                                <div
                                    className={css(
                                        styles.overlay,
                                        activeFilterGroupCollectionPanelType === 'small' ?
                                            styles.overlay_sixtysix : styles.overlay_fullwidth
                                    )}
                                /> : null
                        }
                        <FilterButtonBar
                            activeFilterGroupCollectionIndex={activeFilterGroupCollectionIndex}
                            disableOnClickOutside={
                                Number(activeFilterGroupCollectionIndex) === -1
                            }
                            filterGroupCollections={filterGroupCollections}
                            getActiveFilters={getActiveFilters}
                            setActiveFilterGroupCollection={setActiveFilterGroupCollection}
                            updateFilterGroupCollection={updateFilterGroupCollection}
                            isAdmin={isAdmin}
                            toggleAdminMode={toggleAdminMode}
                        />
                    </div>
                    <div className={css(styles.filterBarWrapperRelative)} />
                </div>
                <div
                    className={css(styles.outContainer)}
                    aria-hidden="false"
                    data-id="FloatingFilterButtonWrapper"
                >
                    <div className={css(styles.container_withMdSplitMap)}>
                        <div className={css(styles.buttonContainer, styles.screenSmButton)}>
                            {
                                mapState.mapPanelVisible ?
                                    <button
                                        className={css(styles.button, styles.buttonLeft)}
                                        onClick={toggleMapPanel}
                                    >
                                        <span className={css(styles.wrapper)}>
                                            <div className={css(styles.containerTable)}>
                                                <div className={css(styles.containerTableChild)}>
                                                    <span>
                                                        <Translatable
                                                            content={{
                                                                transKey: 'search.list'
                                                            }}
                                                        />
                                                    </span>
                                                </div>
                                                <div className={css(styles.containerTableChild)}>
                                                    <div style={{ marginLeft: '6px' }}>
                                                        <div className={css(styles.icon)}>
                                                            <svg
                                                                viewBox="0 0 12 4"
                                                                role="presentation"
                                                                aria-hidden="true"
                                                                focusable="false"
                                                                style={{
                                                                    display: 'block',
                                                                    fill: 'currentcolor',
                                                                    height: '1em',
                                                                    width: '1em'
                                                                }}
                                                            >
                                                                <path
                                                                    fillRule="evenodd"
                                                                    d="M10.5 3.5a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 10.5 3.5zM6 3.5A1.5 1.5 0 1 0 5.999.499 1.5 1.5 0 0 0 6 3.5zm-4.5 0A1.5 1.5 0 1 0 1.499.499 1.5 1.5 0 0 0 1.5 3.5z"
                                                                />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </span>
                                    </button> :
                                    <button
                                        className={css(styles.button, styles.buttonLeft)}
                                        onClick={toggleMapPanel}
                                    >
                                        <span className={css(styles.wrapper)}>
                                            <div className={css(styles.containerTable)}>
                                                <div className={css(styles.containerTableChild)}>
                                                    <span>
                                                        <Translatable
                                                            content={{
                                                                transKey: 'search.map'
                                                            }}
                                                        />
                                                    </span>
                                                </div>
                                                <div className={css(styles.containerTableChild)}>
                                                    <div style={{ marginLeft: '6px' }}>
                                                        <div className={css(styles.icon)}>
                                                            <svg
                                                                viewBox="0 0 12 12"
                                                                role="presentation"
                                                                aria-hidden="true"
                                                                focusable="false"
                                                                style={{
                                                                    display: 'block',
                                                                    fill: 'currentcolor',
                                                                    height: '1em',
                                                                    width: '1em'
                                                                }}
                                                            >
                                                                <path
                                                                    fillRule="evenodd"
                                                                    d="M10.377.76l-2.816.469L4.738.288a.753.753 0 0 0-.474 0l-3 1a.75.75 0 0 0-.513.711v9a.75.75 0 0 0 .987.711l2.763-.921 2.763.921c.154.051.32.051.474 0l3-1a.75.75 0 0 0 .513-.711v-8.5a.75.75 0 0 0-.873-.74l-.001.001zM2.25 9.959V2.54l1.5-.5v7.419l-1.5.5zm3-7.919l1.5.5v7.419l-1.5-.5V2.04zm3 .595l1.5-.25v7.074l-1.5.5V2.635z"
                                                                />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </span>
                                    </button>
                            }
                            <div className={css(styles.filtersButtonWrapper)}>
                                <div className={css(styles.dividerOuter)}>
                                    <div className={css(styles.divider)} />
                                </div>
                                <button
                                    className={css(styles.button, styles.buttonLeft)}
                                    onClick={toggleFullScreenPanel}
                                >
                                    <span className={css(styles.wrapper)}>
                                        <div className={css(styles.containerTable)}>
                                            <div className={css(styles.containerTableChild)}>
                                                <span>
                                                    <Translatable
                                                        content={{
                                                            transKey: 'search.filters'
                                                        }}
                                                    />
                                                </span>
                                            </div>
                                            <div className={css(styles.containerTableChild)}>
                                                <div style={{ marginLeft: '6px' }}>
                                                    <div className={css(styles.icon)}>
                                                        <svg
                                                            viewBox="0 0 12 12"
                                                            role="presentation"
                                                            aria-hidden="true"
                                                            focusable="false"
                                                            style={{
                                                                display: 'block',
                                                                fill: 'currentcolor',
                                                                height: '1em',
                                                                width: '1em'
                                                            }}
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M2.5.25a.75.75 0 0 0-.75.75v.378a2.25 2.25 0 0 0 0 4.244V11a.75.75 0 0 0 1.5 0V5.622a2.25 2.25 0 0 0 0-4.244V1A.75.75 0 0 0 2.5.25zm0 4a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm3.5-4a.75.75 0 0 0-.75.75v5.378a2.25 2.25 0 0 0 0 4.244V11a.75.75 0 0 0 1.5 0v-.378a2.25 2.25 0 0 0 0-4.244V1A.75.75 0 0 0 6 .25zm0 9a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm4.25-7.872V1a.75.75 0 0 0-1.5 0v.378a2.25 2.25 0 0 0 0 4.244V11a.75.75 0 0 0 1.5 0V5.622a2.25 2.25 0 0 0 0-4.244zM9.5 4.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5z"
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </span>
                                    {
                                        getActiveFilters > 0 ?
                                            <span className={css(styles.wrapper)}>
                                                <div
                                                    className={css(display.inlineBlock)}
                                                    style={{ marginLeft: '6px' }}
                                                >
                                                    <div
                                                        className={css(styles.badgeContainer)}
                                                        aria-label={`${getActiveFilters} filters applied`}
                                                    >
                                                        {getActiveFilters}
                                                    </div>
                                                </div>
                                            </span> : null
                                    }
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterBar);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterBar.jsx